export const TOGGLE_PDP_MODAL = 'toggle_pdp_modal';
